import { firstCharLowercase } from '@/assets/scripts/strings'

/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** saves holder data
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsuranceholder
*/
export const SAVE_HOLDER_DATA = (state, payload) => {
    state.holder = payload
}

/** saves domain data
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurancelovsdomain
*/
export const SAVE_DOMAIN_DATA = (state, { data, domainName }) => {
    const domain = decodeURIComponent(domainName)
    state[firstCharLowercase(domain.replace(/\s/g, ''))] = data
}

/** saves quotation data
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetinsurance%7BproductCode%7Dquotationsubmit
*/
export const SAVE_QUOTATION = (state, payload) => {
    state.quotation = payload
}

/** saves documents
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetinsurance%7BinsuranceId%7Dreceipt%7BreceiptId%7Ddocuments
*/
export const SAVE_DOCUMENTS = (state, payload) => {
    state.documents = payload
}
/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.accountsBalances = []
    state.holder = {}
    state.travelProtectionPlan = []
    state.travelCapitalSscale = []
    state.gender = []
    state.province = []
    state.city = []
    state.addressCountry = []
    state.country = []
    state.quotation = {}
    state.aUTBrand = []
    state.aUTModel = []
    state.aUTCapitalCRBAI = []
    state.civilStatus = []
}
